<template>
  <div>
    <div class="relative bg-light-purple flex items-center featured-container">
      <div class="container pax20 flex justify-center items-center-l tc">
        <div class="featured-image-container absolute absolute--fill z-0">
          <img
            :data-srcset="require('~/assets/images/costs-cover.jpg').srcSet"
            data-src="~assets/images/costs-cover.jpg"
            class="image-cover lazyload"
            alt="Costs cover"
          />
        </div>
        <div class="absolute absolute--fill z-1 bg-linear-gradient"></div>
        <div class="white z-2 pa2 pl0-l pr4-l mb5-l">
          <h1 class="ma0 mb4 mt4-l lh-title f1">
            {{ $t('prices.heading') }}
          </h1>
          <p class="dn db-l pb3 mb4 fs-subheading">
            {{ $t('prices.subheading') }}
          </p>
        </div>
      </div>
    </div>
    <div>
      <div class="container pax20">
        <div class="pv4">
          <nuxt-link :to="localePath({ name: 'index' })" class="mr1"
            ><img
              src="~/assets/icons/ic_home.svg"
              width="16"
              height="16"
              class="v-mid"
          /></nuxt-link>
          <img
            src="~/assets/icons/ic_arrow_bc.svg"
            width="6"
            height="10"
            class="mr1"
          />
          {{ $t('navigation.costs') }}
        </div>
        <FaqItem
          v-for="(item, index) in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :key="index"
          :title="$t(`prices.faq.${index}.title`)"
          :text="$t(`prices.faq.${index}.text`)"
        />
      </div>
    </div>
    <div class="bg-near-white">
      <DownloadNow />
    </div>
  </div>
</template>

<script>
import DownloadNow from '~/components/DownloadNow';
import FaqItem from '~/components/FaqItem';

export default {
  scrollToTop: true,
  components: {
    DownloadNow,
    FaqItem,
  },
};
</script>
